import { RouteObject } from 'react-router';

import { PourAvailabilityDetails } from './PourAvailabilityDetails';
import { PourAvailabilityList } from './PourAvailabilityList';
import { StandardDrinkDetails } from './StandardDrinkDetails';
import { StandardDrinksList } from './StandardDrinkList';

export const MASTER_MENU_ROUTES: RouteObject[] = [
    { path: 'standard-drinks', Component: StandardDrinksList },
    { path: 'standard-drinks/:id', Component: StandardDrinkDetails },
    { path: 'pour-availability', Component: PourAvailabilityList },
    { path: 'pour-availability/:id', Component: PourAvailabilityDetails },
];
